import styled, { css } from 'styled-components';
import { px2rem, themeVariant } from '../utils/helpers/style.js';
import { styles } from '../constants/styles.js';
import { boxStyles } from '../Box/styles.js';
import { fontFamilyStyles } from '../ContentText/styles.web.js';
import { getButtonStyles } from './utils.js';
import { BoxPropsMapping } from '../Box/props.js';
import { getComponentVariant } from '../utils/theming/getComponentVariant.js';

// these are excluded from underlying element rendered with styled-components
// HOX! Remember to add any new props to this list
var excludedButtonProps = ['color', 'invert', 'status', 'withLeftIcon', 'withRightIcon', 'transparent', 'disabledStyle', 'disabledColor', 'borderRadius', 'textColorProp', 'theme'].concat(Object.keys(BoxPropsMapping));
function buttonPaddings(_ref) {
  var theme = _ref.theme,
      withLeftIcon = _ref.withLeftIcon,
      withRightIcon = _ref.withRightIcon,
      status = _ref.status,
      variant = _ref.variant;
  var buttonTheme = getComponentVariant(theme.button.web, variant);
  var fromSide = px2rem(buttonTheme.paddings.fromSide);
  var afterIcon = px2rem(buttonTheme.paddings.afterIcon);
  var borderWidth = px2rem(buttonTheme.borders.width);
  var iconSize = px2rem(buttonTheme.icon.size);
  var totalPadding = "calc(".concat(fromSide, " - ").concat(borderWidth, " + ").concat(iconSize, " + ").concat(afterIcon, ")");
  var top = '';
  var bottom = '';
  var horizontal = '';
  top = "\n    padding-top: ".concat(typeof buttonTheme.paddings.top === 'number' ? px2rem(buttonTheme.paddings.top) : buttonTheme.paddings.top, ";\n  ");
  bottom = "\n    padding-bottom: ".concat(typeof buttonTheme.paddings.bottom === 'number' ? px2rem(buttonTheme.paddings.bottom) : buttonTheme.paddings.bottom, ";\n  ");

  if (buttonTheme.paddings.mode === 'text-in-middle') {
    horizontal = "\n      padding-left: ".concat(withLeftIcon ? "calc(".concat(fromSide, " - ").concat(borderWidth, ")") : withRightIcon ? status === 'plain' ? px2rem(buttonTheme.paddings.plain) : totalPadding : totalPadding, ";\n      padding-right: ").concat(withRightIcon ? "calc(".concat(fromSide, " - ").concat(borderWidth, ")") : withLeftIcon ? status === 'plain' ? px2rem(buttonTheme.paddings.plain) : totalPadding : totalPadding, ";\n    ");
  } else if (buttonTheme.paddings.mode === 'balanced') {
    horizontal = "\n      padding-left: calc(".concat(fromSide, " - ").concat(borderWidth, ");\n      padding-right: calc(").concat(fromSide, " - ").concat(borderWidth, ");\n    ");
  }

  return css(["", " ", " ", ""], top, bottom, horizontal);
}
var baseButtonStyles = /*#__PURE__*/css(["text-decoration:none;-webkit-appearance:none;-webkit-tap-highlight-color:rgba(0,0,0,0);outline:none;border:none;::-moz-focus-inner{border:none;}box-sizing:border-box;", " transition:background ", ",color ", ",border ", ";transition-timing-function:", ";", ""], getButtonStyles('normal'), styles.transition.timing.base, styles.transition.timing.base, styles.transition.timing.base, styles.transition["function"].base, function (props) {
  return props.disabled || props.disabledStyle ? css(["", " cursor:not-allowed;"], getButtonStyles('disabled')) : css(["@media (hover:hover){&:hover{", " cursor:pointer;}}&:focus{", "}&:active{", " transition:unset;}"], getButtonStyles('hover'), getButtonStyles('focus'), getButtonStyles('click'));
});
var text = /*#__PURE__*/styled.span.withConfig({
  displayName: "styles__text",
  componentId: "sc-1xur2jf-0"
})(["display:inline-block;margin-top:", ";"], function (props) {
  return px2rem(props.theme.button.web.margins.text.top);
});
var pickIconLeftPadding = themeVariant({
  normal: function normal(props) {
    return props.withLeftIcon ? px2rem(props.theme.button.web.paddings.afterIcon) : 0;
  },
  condensed: function condensed(props) {
    return props.withLeftIcon ? // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    px2rem(props.theme.button.web.variants.condensed.paddings.afterIcon) : 0;
  }
});
var pickIconRightPadding = themeVariant({
  normal: function normal(props) {
    return props.withRightIcon ? px2rem(props.theme.button.web.paddings.afterIcon) : 0;
  },
  condensed: function condensed(props) {
    return props.withRightIcon ? // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    px2rem(props.theme.button.web.variants.condensed.paddings.afterIcon) : 0;
  }
});
var buttonTextStyles = /*#__PURE__*/css(["text-align:", ";padding-left:", ";padding-right:", ";"], function (props) {
  return props.textAlign ? props.textAlign : 'center';
}, pickIconLeftPadding, pickIconRightPadding);
var button = /*#__PURE__*/styled.button.withConfig({
  shouldForwardProp: function shouldForwardProp(prop) {
    return !excludedButtonProps.includes(prop);
  }
}).withConfig({
  displayName: "styles__button",
  componentId: "sc-1xur2jf-1"
})(["", " ", " -webkit-appearance:none;text-decoration:none;outline:none;::-moz-focus-inner{border:none;}cursor:pointer;display:inline-flex;justify-content:center;height:", ";font-size:", ";font-weight:", ";border-radius:", ";position:relative;text-align:left;", "{", ";}", " ", ""], fontFamilyStyles, buttonPaddings, themeVariant({
  normal: function normal(props) {
    return px2rem(props.theme.button.web.height[props.size]);
  },
  condensed: function condensed(props) {
    return px2rem(props.theme.button.web.height.condensed);
  }
}), themeVariant({
  normal: function normal(props) {
    return px2rem(props.theme.button.web.font.size[props.size]);
  },
  condensed: function condensed(props) {
    return px2rem(props.theme.button.web.font.size.condensed);
  }
}), themeVariant({
  normal: function normal(props) {
    return props.theme.button.web.font.weight[props.size];
  },
  condensed: function condensed(props) {
    return props.theme.button.web.font.weight.condensed;
  }
}), function (props) {
  return px2rem(props.theme.button.web.borders.radius);
}, text, buttonTextStyles, baseButtonStyles, boxStyles);

export { baseButtonStyles, button, buttonPaddings, buttonTextStyles, excludedButtonProps, text };
